import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import "./App.css";
import InitialConfiguration from "./components/InitialConfiguration/InitialConfiguration";
import {
  getIsInitialConfigurationNeeded,
  getIsInitialConfigurationNeededFetchStatus,
} from "./redux/reducers/InitialConfigurationReducer";
import { useTypedSelector } from "./redux/reducers/RootReducer";
import Auth from "./Auth";
import Wait from "./Wait";
import { fetchIsNeedInitialConfiguration } from "./components/FetchInitialConfiguration";
import ForgotPassword from "./components/Login/ForgotPassword";
import ResetPassword from "./components/Login/ResetPassword";
import { getNotifications } from "./redux/reducers/NotificationReducer";
import { getModalNotifications } from "./redux/reducers/ModalNotificationReducer";
import { ENotificationType } from "./Model/ENotificationType";
import ModalNotificationView from "./components/Common/ModalNotification";
import Notification from "./components/Common/Notification";
import { removeNotification } from "./redux/actions/NotificationAction";
import { fetchEnableAuthenticationSetting } from "./components/FetchAuthenticationSetting";
import { getIsAuthenticationEnableFetchStatus } from "./redux/reducers/AuthenticationSettingReducer";



function App() {
  const dispatch = useDispatch();
  const history = useHistory();
  const location = useLocation();

  const fetchIsInitialConfigurationNeededStatus = useTypedSelector((state) =>
    getIsInitialConfigurationNeededFetchStatus(state)
  );
  const featchAuthenticationEnableStatus = useTypedSelector((state) =>
    getIsAuthenticationEnableFetchStatus(state)
  );

  const isInitialConfigurationNeeded = useTypedSelector((state) =>
    getIsInitialConfigurationNeeded(state)
  );
  const notifications = useTypedSelector((state) => getNotifications(state));
  const modalNotifications = useTypedSelector((state) =>
    getModalNotifications(state)
  );

  const onNotificationClosed = () => {
    dispatch(removeNotification());
  };

  useEffect(() => {
    dispatch(fetchIsNeedInitialConfiguration());
  }, [dispatch]);

  useEffect(() => {
    if(fetchIsInitialConfigurationNeededStatus.completed && !isInitialConfigurationNeeded.isNeedInitialConfiguration)
      dispatch(fetchEnableAuthenticationSetting());
  }, [fetchIsInitialConfigurationNeededStatus.completed, isInitialConfigurationNeeded.isNeedInitialConfiguration])

  const notification = notifications[0];
  const modalNotification = modalNotifications[0];
  //ToDo: Create a proper handling to folowup waiting backend value before rendering anythings
  if (!fetchIsInitialConfigurationNeededStatus.completed) {
    return <Wait message="Loading Configuration" />;
  }

  if (fetchIsInitialConfigurationNeededStatus.error) {
    return <Wait message={fetchIsInitialConfigurationNeededStatus.error} />;
  }
  if (featchAuthenticationEnableStatus.error) {
    return <Wait message={featchAuthenticationEnableStatus.error} />;
  }

  if (location.pathname.startsWith("/forgot-password")) {
    return (
      <div className="App">
        <ForgotPassword />
      </div>
    );
  }

  if (location.pathname.startsWith("/reset-password")) {
    return (
      <div className="App">
        <ResetPassword />
      </div>
    );
  }
  const buildNotificationView = () => {
    return <div>
      <Notification
        type={notification?.type ?? ENotificationType.Info}
        active={notification != null}
        message={notification?.message}
        onClose={onNotificationClosed}
      />
      <ModalNotificationView
        headerText={modalNotification?.headerText}
        bodyTitleText={modalNotification?.bodyTitleText}
        bodySubTitleText={modalNotification?.bodySubTitleText}
        type={modalNotification?.type ?? ENotificationType.Warning}
        show={modalNotification != null}
        onHide={() => { }}
        onClickOk={modalNotification?.onClickOk}
        onClickCancel={modalNotification?.onClickCancel}
        okLabel={modalNotification?.okLabel}
        cancelLabel={modalNotification?.cancelLabel}
      />
    </div>
  }

  if (
    location.pathname === "/initial-configuration" ||
    isInitialConfigurationNeeded.isNeedInitialConfiguration
  ) {
    return (
      <div className="App">
        {buildNotificationView()}
        <InitialConfiguration
          isNeedInitialConfiguration={
            isInitialConfigurationNeeded.isNeedInitialConfiguration
          }
        />
      </div>
    );
  }
  return <div>
    {buildNotificationView()}
    <Auth />
  </div>;
}

export default App;
